import {
  Component,
  ViewEncapsulation,
  ElementRef,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';

import { ButtonComponent } from '../shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-print-help',
  templateUrl: './print-help.component.html',
  styleUrls: ['./print-help.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ButtonComponent, TranslateModule],
})
export class PrintHelpComponent {
  @Input() isBrowserSupport = true;
  @Output() print = new EventEmitter();

  constructor(elementRef: ElementRef<HTMLElement>) {
    elementRef.nativeElement.classList.add('qa-print-help');
  }
}
